"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Gift = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.835 2.747c-2.444-.489-4.621 1.62-4.211 4.078l.02.126c.063.373.18.726.344 1.049H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2.988c.163-.323.281-.676.343-1.05l.021-.125c.41-2.458-1.767-4.567-4.211-4.078a3.562 3.562 0 0 0-2.609 2.17L12 6.307l-.556-1.39a3.562 3.562 0 0 0-2.609-2.17zM11 10H3v2h8v-2zm0 4H5v5h6v-5zm2 5v-5h6v5h-6zm0-7v-2h8v2h-8zm4.383-5.378A1.65 1.65 0 0 1 15.759 8h-2.282l.936-2.34a1.562 1.562 0 0 1 2.99.836l-.02.126zM10.523 8l-.936-2.34a1.562 1.562 0 0 0-2.99.836l.02.126A1.65 1.65 0 0 0 8.241 8h2.282z", fill: fill || 'currentColor' })));
};
exports.default = Gift;
